<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header *ngIf="contentHeader" [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-title px-1 pt-2 w-100">
        <div class="row" *ngIf="_utilService.isDesktop">
          <div class="col-md-8 col-12">
            <div class="d-flex">
              <div class="mr-1">
                <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control w-fit" [(ngModel)]="searchKeyword" />
              </div>
            </div>
          </div>
          <div class="col-md-4 col-12">
            <div class="d-flex justify-content-end">
              <div class="d-inline-block mr-2">
                <label class="d-flex align-items-center mb-0"
                  >{{ "SHOW" | translate }}
                  <select class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="_utilService.isMobile || _utilService.isTablet" class="row">
          <div class="col-12">
            <input type="search" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKeyword" />
          </div>
          <div class="col-12 my-1">
            <ng-select [(ngModel)]="selectedCategory" class="font-small-4 font-weight-normal">
              <ng-option disabled="disabled" value="all">{{ "CATEGORY" | translate }}</ng-option>
              <ng-option value="all">{{ "ALL" | translate }}</ng-option>
              <ng-option *ngFor="let cat of categories" [value]="cat.name">{{ cat.parent_id ? "&#8211;" : "" }} {{ cat.name }}</ng-option>
            </ng-select>
          </div>
        </div>
      </div>
      <!--desktop-->
      <div class="card-body p-0" *ngIf="_utilService.isDesktop">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="config.headerHeight"
          [scrollbarH]="config.scrollbarH"
          [rowHeight]="config.rowHeight"
          [limit]="tableLimit"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [footerHeight]="config.footerHeight"
          [rows]="documentList()"
        >
          <ngx-datatable-column name="{{ 'DOCUMENT' | translate }}" prop="title" [sortable]="true" width="400">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="line-height-2">{{ row.title }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'DATE' | translate }}" prop="send_date" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="line-height-1">{{ _utilService.formatDate(row.send_date) }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'STATUS_SIGNATURE' | translate }}" prop="send_date" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="badge badge-pill badge-light-{{ _documentService.document_status_signature_sended[row.user_data[0].status].color }} mr-1" *ngIf="row.user_data[0].signed == 1 && row.require_signature == 1">{{
                _documentService.document_status_signature_sended[row.user_data[0].status].label | translate
              }}</span>
              <span class="badge badge-pill badge-light-{{ _utilService.dateIsInThreeDays(row.end_date) ? 'danger' : 'warning' }} mr-1" *ngIf="row.end_date && row.user_data[0].signed == 0 && row.require_signature == 1"
                >{{ "NOT_SIGNED" | translate }} {{ "WITHIN" | translate }} {{ _utilService.formatDate(row.end_date, "DD/MM/YY") }}</span
              >
              <span class="badge badge-pill badge-light-danger mr-1" *ngIf="!row.end_date && row.user_data[0].signed == 0 && row.require_signature == 1">{{ "NOT_SIGNED" | translate }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <button class="btn btn-outline-secondary btn-sm" (click)="goToDocument(row)">{{ "VIEW" | translate }}</button>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>

      <!--mobile & tablet-->
      <div class="card-body p-0" *ngIf="_utilService.isMobile || _utilService.isTablet">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="config.headerHeight"
          [scrollbarH]="false"
          [rowHeight]="170"
          [limit]="tableLimit"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [footerHeight]="config.footerHeight"
          [rows]="documentList()"
        >
          <ngx-datatable-column name="{{ 'DOCUMENT' | translate }}" prop="title" sortable="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <div class="col-8">
                  <div>
                    <span class="line-height-1">{{ row.title }}</span>
                  </div>
                  <div>
                    <span class="line-height-1">{{ _utilService.formatDate(row.send_date) }}</span>
                  </div>
                </div>
                <div class="col-4 d-flex align-items-center justify-content-center pl-0">
                  <div>
                    <button class="btn btn-outline-secondary btn-sm" (click)="goToDocument(row)">{{ "VIEW" | translate }}</button>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>
